import { render, staticRenderFns } from "./SnackView.vue?vue&type=template&id=d5553e9c&scoped=true"
import script from "./SnackView.vue?vue&type=script&lang=js"
export * from "./SnackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5553e9c",
  null
  
)

export default component.exports